import React from 'react';
import { Glyphicon } from 'react-bootstrap'
import InputBox from '../../components/InputBox'

class FaxBox extends React.Component {

	// Public
	setValue = (value) => { this._input.setValue(value); }
	getValue = () => { this._input.getValue(); }
	focus = () => { this._input.focus(); }
	select = () => { this._input.select(); }
	flag = (status) => { this._input.flag(status); }
	completed = () => { return this._input.completed(); }
	validate = () => { return null; }

	// React
	render() {
		const props = {
			...this.props
		}

		return (
			<div className="input-group">
				<InputBox {...props} ref={(input) => this._input = input} />
				<div className="input-group-addon">
					<Glyphicon glyph="print" />
				</div>
			</div>)
	}
}

export default FaxBox;

// Mark this as a form component
FaxBox.defaultProps = {
	formControl: true,
	managed: false,
	maxLength: 20
};



// WEBPACK FOOTER //
// ./src/fw/forms/controls/faxBox/FaxBox.js